<template>
  <div>
    <template v-if="record?.projectSystemInfos?.length">
      <!--      合同状态-->
      <template v-if="slotType==='projectSystemInfos_contractStatus'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div v-if="getContractStatus(row).isFlag">
            <el-tag :type="getContractStatus(row).color">{{ getContractStatus(row).name }}</el-tag>
          </div>
          <div v-else></div>
        </div>
      </template>
      <!--      合同分类-->
      <template v-else-if="slotType==='projectSystemInfos_contractType'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div>
            <el-tag v-if="row?.contractInfo?.contractType==='FORMAL'" type="success">正式</el-tag>
            <el-tag v-else-if="row?.contractInfo?.contractType==='CHARGEBACKS'" type="primary">扣款</el-tag>
            <el-tag v-else-if="row?.contractInfo?.contractType==='DEVELOPMENT'" type="warning"
                    style="border-color: rgb(209,252,250);color: rgb(27,138,155); background-color: rgb(209,252,250);">
              研发
            </el-tag>
          </div>
        </div>
      </template>
      <!--      测序平台-->
      <div v-else-if="slotType==='projectSystemInfos_sequencingPlatform'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div>{{ getSequencingPlatform(row, row.contractInfo) }}</div>
        </div>
      </div>
      <!--      合同数据量-->
      <template v-else-if="slotType==='projectSystemInfos_planAmountSet'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div>{{ row.planAmount ? (row.planAmount + (row.dataAmountUnit ? `(${row.dataAmountUnit})` : '')) : '' }}
          </div>
        </div>
      </template>
      <template v-else-if="slotType==='projectSystemInfos_planAmountSet1'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div>
            {{ (row?.contractInfo?.planAmountSet?.length) ? (Math.max(...row.contractInfo.planAmountSet) + (row.dataAmountUnit ? `(${row.dataAmountUnit})` : '')) : '' }}
          </div>
        </div>
      </template>
      <!--      数据量是否足够-->
      <div v-else-if="slotType==='projectSystemInfos_dataEnoughStatus'" slot-scope="{text,record}">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div v-if="row.isPure">
            <div style="color:#28b22f; ">NA</div>
          </div>
          <div v-else>
            <el-tag v-if="row.dataStatus==='ENOUGH_ALL_ON'" type="success">足够,全部上机且足够</el-tag>
            <el-tag v-else-if="row.dataStatus==='ENOUGH_PART_ON'" style="color: #dd6161">足够,部分上机且足够</el-tag>
            <el-tag v-else-if="row.dataStatus==='LACK_ALL_ON'" type="warning" style="color: #dd6161">
              不够,全部样本已上机
            </el-tag>
            <el-tag v-else-if="row.dataStatus==='LACK_PART_ON'" type="danger">不够,部分已上机</el-tag>
            <el-tag v-else type="info">未上机</el-tag>
          </div>

        </div>
      </div>
      <template v-else-if="slotType==='projectSystemInfos_analyzeRequirements'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div>{{
              row?.contractInfo?.analyzeRequirements ? row.contractInfo.analyzeRequirements.replaceAll("/", ";") : ''
            }}
          </div>
        </div>
      </template>
      <template v-else-if="slotType==='projectSystemInfos_contractSampleNum'" style="color: #e8e8e8">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div :style="getContractSampleNum(row)==='NA'?'color:#66c03b':''">{{ getContractSampleNum(row) }}</div>
        </div>
      </template>
      <template v-else-if="slotType==='projectSystemInfos_sampleNum'">
        <div class="projectSystemInfos" v-for="row in record.projectSystemInfos">
          <div>{{ row.sampleNum }}</div>
        </div>
      </template>
    </template>
    <template v-else>

    </template>

  </div>

</template>
<script>
function newContractRule(value) {
  const rule = /^(BZ)(?<del>[D|F]?)(\d{14})$/
  if (value) {
    if (rule.test(value)) {
      return true
    }
  }
  return false
}

const contractStatus = {
  APPLYING: {
    name: '待审核',
    color: 'warning'
  },
  SUCCESS: {
    name: '已通过',
    color: 'success'
  },
  DEFEAT: {
    name: '已拒绝',
    color: 'danger'
  },
  DERELICT: {
    name: '已终止',
    color: 'info'
  },
}
export default {
  name: "ApprovalTableSlot",
  props: {
    record: {
      default: () => ({})
    },
    slotType: {
      default: ''
    },
  },
  methods: {
    // 获取合同状态
    getContractStatus(row) {
      let isNewContract = newContractRule(row.contractNo)
      if (isNewContract && row?.contractInfo?.contractStatus) {
        return {
          isFlag: true,
          name: contractStatus[row.contractInfo.contractStatus].name,
          color: contractStatus[row.contractInfo.contractStatus].color,
        }
      }
      return {
        isFlag: false
      }
    },
    // 测序平台
    getSequencingPlatform(row, contractInfo) {
      let isNewContract = newContractRule(row.contractNo)
      if (isNewContract) {
        if (contractInfo?.sequencingPlatform) {

        } else {
          return
        }

        return (contractInfo?.sequencingPlatform) ? (contractInfo?.sequencingPlatform + (contractInfo?.thirdSequencingPlatform ? `/${contractInfo.thirdSequencingPlatform}` : '')) : ''
      }
      return ''

    },
    getContractSampleNum(row) {
      return row.contractInfo.contractProjectType === 'ONLY_ANALYSIS' ? 'NA' : row.contractInfo.contractSampleNum
    }
  }
}
</script>


<style>

.projectSystemInfos_td {
  padding: 0px !important;
}

.projectSystemInfos_td .ant-table-header-column {
  display: flex;
  justify-content: center;
  padding: 10px;

}

.projectSystemInfos:not(:last-child) {
  border-bottom: 1px solid #e8e8e8;
  text-align: center;
}

.projectSystemInfos {
  text-align: center;
}

.projectSystemInfos div {
  padding: 15px;
  display: flex;
  align-items: center;


}
</style>
